import React from 'react'
// import { FieldContract } from '../Common/FieldsForForms'
import { LinearLoading } from 'common'
import { Box, Button, Checkbox, FormControl, FormControlLabel, Grid, IconButton, TextField, Typography } from '@mui/material'
import { CustomAutocomplete } from 'common'
import { FieldContract, InfoContract } from '../Common'
import { FileManagerInput } from 'common'
import { CheckCircle, Download, Plus, Trash2, UploadCloud, XCircle } from 'react-feather'
import { DepositTable } from './GSPRemovalSection/DepositTable'

const acceptConfiguration = {
    'application/pdf': []
}

export const CreditRefinancing = ({ useFetchInit }) => {
    const { 
        //------------- Generales
        location,
        paramsURL,
        //------------- globalStates
        globalStates,
        //------------- FetchData
        FetchData,
        //------------- Actions
        Actions,
        //------------- helpers
        Helpers,
        //------------- Formularios
        Forms
        
    } = useFetchInit

        // ------------------------------------------------ Formularios
        const { FormRequestGlobal } = Forms
        const { 
            formState, 
            onInputChange, 
            onInputChangeForNumber,
            onDropZoneAcceptedFilesChange, 
            onDropZoneRejectionsFilesChange, 
        } = FormRequestGlobal

        const { formOpeningMode} = globalStates

        //------------------------------------------------- Fech data

        //------------------------------------------------- Actions
        const {
            handleChangeTypeLoan, 
            handleChangeTerm, 
            handleChangeGPS, 
            handleChangeOtros,
            handleChangeSeguro,
            handleChangeMount
        } = Actions

    return (
        <>
            <Typography sx={{mt:3,fontWeight: 'bold'}} variant='subtitle2'>
                Informacion sobre la gestion
            </Typography>
            <div className="border-bottom border-dark"></div>
            <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{mb: 1, mt: 2}}>
                       
                <Grid item xs={12} sm={12} md={4} lg={4} sx={{mb: 1, mt: 3}}>
                    <FormControl fullWidth>
                    <label htmlFor="saldo_financiar">Monto Original del Credito (Q)</label>
                    <TextField
                        id='saldo_financiar'
                        name='saldo_financiar'
                        value={ formState.saldo_financiar }
                        onChange={ onInputChange }
                        size='small'
                        placeholder='Monto a Financiar'
                        type='text'
                        variant='filled'
                        InputProps={{
                            readOnly: true
                        }}
                        required
                    />
                    </FormControl>
                </Grid>
                
                <Grid item xs={12} sm={12} md={4} lg={4} sx={{mb: 1, mt: 3}}>
                    <FormControl fullWidth>
                        <label htmlFor="total_gastos_juridicos">Deuda Gastos Juridicos (Q)</label>
                        <TextField
                            id='total_gastos_juridicos'
                            name='total_gastos_juridicos'
                            value={ formState.total_gastos_juridicos }
                            onChange={ onInputChange }
                            size='small'
                            placeholder='Deuda Gastos Juridicos'
                            type='text'
                            variant={'filled'}
                            InputProps={{readOnly: true}}
                            required
                        />
                    </FormControl>
                </Grid>

                <Grid item xs={12} sm={12} md={4} lg={4} sx={{mb: 1, mt: 3}}>
                    <FormControl fullWidth>
                        <label htmlFor="total_gastos_admin">Deuda Gastos Administrativos (Q)</label>
                        <TextField
                            id='total_gastos_admin'
                            name='total_gastos_admin'
                            value={ formState.total_gastos_admin }
                            onChange={ onInputChange }
                            size='small'
                            placeholder='Deuda Gastos Administrativos'
                            type='text'
                            variant={'filled'}
                            InputProps={{readOnly: true}}
                            required
                        />
                    </FormControl>
                </Grid>



                <Grid item xs={12} sm={12} md={6} lg={6} sx={{mb: 1, mt: 3}}>
                    <FormControl fullWidth>
                        <label htmlFor="suma_total_pagar">Capital Restante (Q)</label>
                        <TextField
                            id='suma_total_pagar'
                            name='suma_total_pagar'
                            value={ formState.suma_total_pagar }
                            onChange={ onInputChange }
                            size='small'
                            placeholder='Capital Restante'
                            type='text'
                            variant={'filled'}
                            InputProps={{readOnly: true}}
                            required
                        />
                    </FormControl>
                </Grid>


                 <Grid item xs={12} sm={12} md={6} lg={6} sx={{mb: 1, mt: 3}}>
                    <FormControl fullWidth>
                        <label htmlFor="total_deuda_credito">Total Deuda sin Mora (Q)</label>
                        <TextField
                            id='total_deuda_credito'
                            name='total_deuda_credito'
                            value={ formState.total_deuda_credito }
                            onChange={ onInputChange }
                            size='small'
                            placeholder='Total Deuda sin Mora'
                            type='text'
                            variant={'filled'}
                            InputProps={{readOnly: true}}
                            required
                        />
                    </FormControl>
                </Grid>

                <Grid item xs={12} sm={12} md={6} lg={6} sx={{mb: 1, mt: 3}}>
                    <FormControl fullWidth>
                        <label htmlFor="mora_pendiente">Mora Pendiente al Dia (Q)</label>
                        <TextField
                            id='mora_pendiente'
                            name='mora_pendiente'
                            value={ formState.mora_pendiente }
                            onChange={ onInputChange }
                            size='small'
                            placeholder='Mora Pendiente al Dia'
                            type='text'
                            variant={'filled'}
                            InputProps={{readOnly: true}}
                        />
                    </FormControl>
                </Grid>

                <Grid item xs={12} sm={12} md={6} lg={6} sx={{mb: 1, mt: 3}}>
                    <FormControl fullWidth>
                        <label htmlFor="total_deuda_mora"><b>Total Deuda con Mora al Dia (Q)</b></label>
                        <TextField
                            id='total_deuda_mora'
                            name='total_deuda_mora'
                            value={ formState.total_deuda_mora }
                            onChange={ onInputChange }
                            size='small'
                            placeholder='Total Deuda con Mora al Dia'
                            type='text'
                            variant={'filled'}
                            InputProps={{readOnly: true}}
                        />
                    </FormControl>
                </Grid>
                                      

            </Grid>
            <Typography sx={{mt:3,fontWeight: 'bold'}} variant='subtitle2'>
                Formulario de refinanciamiento
            </Typography>
            <div className="border-bottom border-dark"></div>
            <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{mb: 1, mt: 2}}>

                <Grid item xs={12} sm={12} md={3} lg={3} sx={{mb: 1, mt: 3}}>
                    <FormControl fullWidth> 
                        <label htmlFor="saldo_financiado">* Monto a Refinanciar (Q)</label>
                        <TextField
                            id='saldo_financiado'
                            name='saldo_financiado'
                            value={ formState.saldo_financiado }
                            onChange={ handleChangeMount }
                            size='small'
                            placeholder='Monto de venta'
                            hiddenLabel
                            type='text'
                            variant={(formOpeningMode === 'READONLY') ? 'filled' : 'outlined'}
                            InputProps={{readOnly: (formOpeningMode === 'READONLY') ? true : false}}
                            required
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3} sx={{mb: 1, mt: 3}}>
                    <FormControl fullWidth>
                        <label htmlFor="gestion_nuevo_dia_pago">Nuevo dia de pago</label>
                        <TextField
                            id='gestion_nuevo_dia_pago'
                            name='gestion_nuevo_dia_pago'
                            value={ formState.gestion_nuevo_dia_pago }
                            size='small'
                            placeholder='Nuevo dia de pago'
                            type='date'
                            variant='filled'
                            InputProps={{readOnly: true}}
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3} sx={{mb: 1, mt: 3}}>
                    <FormControl fullWidth>
                    <label htmlFor="interes">* Tipo de interes</label>
                    <TextField
                        id='interes'
                        name='interes'
                        value={ formState.interes }
                        onChange={ handleChangeTypeLoan }
                        size='small'
                        placeholder='Tipo de interes'
                        hiddenLabel
                        type='number'
                        variant={(formOpeningMode === 'READONLY') ? 'filled' : 'outlined'}
                        InputProps={{readOnly: (formOpeningMode === 'READONLY') ? true : false}}
                        required
                    />
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3} sx={{mb: 1, mt: 3}}>
                    <FormControl fullWidth> 
                        <label htmlFor="interes_total">* Interes Anual (%)</label>
                        <TextField
                            id='interes_total'
                            name='interes_total'
                            value={ formState.interes_total }
                            onChange={ onInputChange }
                            size='small'
                            placeholder='Monto de venta'
                            hiddenLabel
                            type='text'
                            variant = 'filled'
                            InputProps={{readOnly: true}}
                            required
                        />
                    </FormControl>
                </Grid>

                <Grid item xs={12} sm={12} md={5} lg={5} sx={{mb: 1, mt: 3}}>
                    <FormControl fullWidth> 
                        <label htmlFor="nuevo_plazo">* Plazo (Meses)</label>
                        <TextField
                            id='nuevo_plazo'
                            name='nuevo_plazo'
                            value={ formState.nuevo_plazo }
                            onChange={ handleChangeTerm }
                            size='small'
                            placeholder='Plazo (meses)'
                            hiddenLabel
                            type='number'
                            variant={(formOpeningMode === 'READONLY') ? 'filled' : 'outlined'}
                            InputProps={{readOnly: (formOpeningMode === 'READONLY') ? true : false}}
                            required
                        />
                    </FormControl>
                </Grid>

                <Grid item xs={12} sm={12} md={1} lg={1}></Grid>

                <Grid item xs={12} sm={12} md={5} lg={5} sx={{mb: 1, mt: 3}}>
                    <FormControl fullWidth> 
                        <label htmlFor="plazo_anios">* Plazo (Años)</label>
                        <TextField
                            id='plazo_anios'
                            name='plazo_anios'
                            value={ formState.plazo_anios }
                            onChange={ onInputChange }
                            size='small'
                            placeholder='Plazo (años)'
                            hiddenLabel
                            type='number'
                            variant='filled'
                            InputProps={{readOnly:true}}
                            required
                        />
                    </FormControl>
                </Grid>

                <Grid item xs={12} sm={12} md={4} lg={4} sx={{mb: 1, mt: 3}}>
                    <FormControl fullWidth> 
                        <label htmlFor="gps">* GPS</label>
                        <TextField
                            id='gps'
                            name='gps'
                            value={ formState.gps }
                            onChange={ handleChangeGPS }
                            size='small'
                            placeholder='GPS'
                            hiddenLabel
                            type='text'
                            variant={(formOpeningMode === 'READONLY') ? 'filled' : 'outlined'}
                            InputProps={{readOnly: (formOpeningMode === 'READONLY') ? true : false}}
                        />
                    </FormControl>
                </Grid>

                <Grid item xs={12} sm={12} md={4} lg={4} sx={{mb: 1, mt: 3}}>
                    <FormControl fullWidth> 
                        <label htmlFor="seguro">* Seguro</label>
                        <TextField
                            id='seguro'
                            name='seguro'
                            value={ formState.seguro }
                            onChange={ handleChangeSeguro }
                            size='small'
                            placeholder='Seguro'
                            hiddenLabel
                            type='text'
                            variant={(formOpeningMode === 'READONLY') ? 'filled' : 'outlined'}
                            InputProps={{readOnly: (formOpeningMode === 'READONLY') ? true : false}}
                        />
                    </FormControl>
                </Grid>

                <Grid item xs={12} sm={12} md={4} lg={4} sx={{mb: 1, mt: 3}}>
                    <FormControl fullWidth> 
                        <label htmlFor="otros">* Otros</label>
                        <TextField
                            id='otros'
                            name='otros'
                            value={ formState.otros }
                            onChange={ handleChangeOtros }
                            size='small'
                            placeholder='Seguro'
                            hiddenLabel
                            type='text'
                            variant={(formOpeningMode === 'READONLY') ? 'filled' : 'outlined'}
                            InputProps={{readOnly: (formOpeningMode === 'READONLY') ? true : false}}
                        />
                    </FormControl>
                </Grid>

                <Grid item xs={12} sm={12} md={5} lg={5} sx={{mb: 1, mt: 3}}>
                    <FormControl fullWidth> 
                        <label htmlFor="nuevo_cuota_niv">* Cuota Nivelada</label>
                        <TextField
                            id='nuevo_cuota_niv'
                            name='nuevo_cuota_niv'
                            value={ formState.nuevo_cuota_niv }
                            onChange={ onInputChange }
                            size='small'
                            placeholder='Cuota Nivelada'
                            hiddenLabel
                            type='text'
                            variant='filled'
                            InputProps={{readOnly:true}}
                            required
                        />
                    </FormControl>
                </Grid>

                <Grid item xs={12} sm={12} md={1} lg={1}></Grid>

                <Grid item xs={12} sm={12} md={5} lg={5} sx={{mb: 1, mt: 3}}>
                    <FormControl fullWidth> 
                        <label htmlFor="nuevo_total_cuota">* Cuota Total</label>
                        <TextField
                            id='nuevo_total_cuota'
                            name='nuevo_total_cuota'
                            value={ formState.nuevo_total_cuota }
                            onChange={ onInputChange }
                            size='small'
                            placeholder='Cuota Total'
                            hiddenLabel
                            type='text'
                            variant='filled'
                            InputProps={{readOnly:true}}
                            required
                        />
                    </FormControl>
                </Grid>

                <Grid item xs={12} sm={12} md={12} lg={12} sx={{ mb: 1, mt: 2 }}>
                    <FormControl fullWidth>
                        <label htmlFor="gestion_descripcion">Descripcion</label>
                        <TextField
                            id='gestion_descripcion'
                            name='gestion_descripcion'
                            value={ formState.gestion_descripcion } 
                            onChange={ onInputChange }
                            size='small'
                            placeholder='Descripcion'
                            type='text'
                            multiline
                            rows={5}
                            variant={(formOpeningMode==='READONLY')? 'filled': 'outlined'}
                            InputProps={{
                                readOnly: (formOpeningMode==='READONLY') ? true: false 
                            }}
                            
                        />
                    </FormControl>
                </Grid>
            </Grid>

            {/* Solo se muestra cuando la gestion ya genero la solicitud del nuevo credito */}
            {formState.gestion_nuevo_idcredito && (
                <>
                    <Typography sx={{mt:3,fontWeight: 'bold'}} variant='subtitle2'>
                        Informacion de nuevo credito
                    </Typography>
                    <div className="border-bottom border-dark"></div>

                    <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{mb: 1, mt: 2}}>
                        <Grid item xs={12} sm={12} md={6} lg={6} sx={{mb: 1, mt: 3}}>
                            <FormControl fullWidth>
                                <label htmlFor="gestion_nuevo_idcredito">Identificador de nuevo credito</label>
                                <TextField
                                    id='gestion_nuevo_idcredito'
                                    name='gestion_nuevo_idcredito'
                                    value={ formState.gestion_nuevo_idcredito }
                                    onChange={ onInputChange }
                                    size='small'
                                    placeholder='Identificador de nuevo credito'
                                    hiddenLabel
                                    type='text'
                                    variant='filled'
                                    InputProps={{readOnly:true}}
                                />
                            </FormControl>
                        </Grid>
                    </Grid>
                </>
            )}
        </>
    )
}
